import { LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useEstablishmentStore } from '../store/establishment';

export function Header() {
  const navigate = useNavigate();
  const { establishment, logout } = useEstablishmentStore();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  if (!establishment) return null;

  return (
    <div className="absolute top-4 right-4">
      <button
        onClick={handleLogout}
        className="flex items-center gap-2 px-3 py-2 text-sm text-gray-600 hover:text-gray-800 
                 bg-white/80 hover:bg-white rounded-lg shadow-sm transition-colors"
      >
        <span className="hidden sm:inline">{establishment.name}</span>
        <LogOut className="w-4 h-4" />
      </button>
    </div>
  );
}